/**
 * Password validation utilities
 * Must match backend validation in backend/src/services/auth/password.ts
 */

export interface PasswordValidationResult {
  isValid: boolean;
  error?: string;
}

/**
 * Validate password strength
 * Requirements:
 * - Minimum 8 characters
 * - Maximum 128 characters
 * - At least one letter
 * - At least one number
 */
export function validatePasswordStrength(password: string): PasswordValidationResult {
  if (password.length < 8) {
    return { isValid: false, error: 'Password must be at least 8 characters' };
  }

  if (password.length > 128) {
    return { isValid: false, error: 'Password must be 128 characters or less' };
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /\d/.test(password);

  if (!hasLetter || !hasNumber) {
    return { isValid: false, error: 'Password must contain at least one letter and one number' };
  }

  return { isValid: true };
}

/**
 * Password requirements text for UI display
 */
export const PASSWORD_REQUIREMENTS = 'Must be 8+ characters with at least one letter and one number';
